export default "__VITE_ASSET__DhYZa0_X__"